<template>
    <div class="VIRTUAL">

        <div class="content">
            <div class="maxtext">Sales Gallery Tour</div>
            <div class="contentdiv">
                <div @click="setvrpop('https://my.matterportvr.cn/show/?m=qZaJkwSi5nD&play=1')" > <img :src="Main.imgserve+'/VR/VT_MP_1BRM.png'" alt=""></div>
                <div @click="setvrpop('https://my.matterportvr.cn/show/?m=ykymcgBJKXY&play=1')"> <img :src="Main.imgserve+'/VR/VT_MP_2BRM.png'" alt=""></div>
                <div @click="setvrpop('https://my.matterport.com/show/?m=FcVEUsTMuer&play=1')"> <img :src="Main.imgserve+'/VR/VT_MP_CP1_3BRM.png'" alt=""></div>
            </div>
            <div class="contentdiv">
                <div @click="setvrpop('https://my.matterport.com/show/?m=hpShBAtehEK&play=1')"> <img :src="Main.imgserve+'/VR/VT_MP_3BRM.png'" alt=""></div>
                <div @click="setvrpop('https://my.matterport.com/show/?m=vp3DoZkYboN&play=1')"> <img :src="Main.imgserve+'/VR/VT_MP_4BRM.png'" alt=""></div>
            </div>
        </div>

        <div class="Pop" v-show="vrpop">
           <div @click="vrpop = !vrpop" style=" position: absolute;right: 14vw; top: 14vh;width: 2vw;">
                <img :src="Main.imgserve+'/btn/BACK.png'" alt="">
            </div>
            <div class="ifr">
                <iframe width="100%" height="100%" :src="vrurl" frameborder="0"></iframe>
            </div>

        </div>

        <div class="left_imgcontent" style="text-align: start;">
            <h2 style="margin-top: 2vh;text-align: end; width: 80%;margin-bottom: 3vh;">VIRTUAL TOUR</h2>
            <div class="maxtexts" style="width: 80%;text-align: end;">MODEL AND</div>
            <div class="maxtexts" style="width: 80%;text-align: end;">SHOW UNIT</div>
            <div class="maxtexts" style="width: 80%;text-align: end;">WALKTHROUGH</div>
        </div>


    </div>
</template>

<script>
export default {
    data() {
        return {
            vrurl:'https://www.mymixgo.com/AUDAX/peakresidences-drone/',
            vrpop:false
        }
    },
    methods:{
        setvrpop(url){
            this.vrpop = !this.vrpop
            this.vrurl = url
        }
    },
    mounted(){

    }
}
</script>

<style lang="less">
    
.VIRTUAL{
    width: 100%;
    height: 100%;
    .content{
        position: relative;
        top: 15%;
        // left: 10%;
        
        width: 80vw;
        height: auto;
        .contentdiv{
            display: flex;
            flex-flow: row;
            justify-content: center;
            // align-items: center;
            div{
                margin: 20px;
                width: 20vw;
                height: 15vw;
                // img{
                //     width: 100%;
                //     height: 100%;
                // }
            }
        }

    }
    .Pop{
        background: url('../assets/BG.png') no-repeat;
        background-size: 100% 100%;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0px;
        left: 0px;
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 999;
        .ifr{
            border: 10px solid #bf9961;
            border-radius: 10px;
            width: 75%;
            height: 75%;
        }
    }
    .maxtexts{
    font-size: 12px;
    font-weight: bold;
}
}


</style>